import { useEffect, useState } from 'react';
import ASRVPMembership from './ASRVP-Membership';
import ASRVPBackgroundScreening from './ASRVP-BackgroundScreening';
import ASRVPTraining from './ASRVP-Training';
import './AthleteSafetyRVP.css'
import useManageApi from '../../hooks/useManageApi';
import { LoadingComponent } from 'usbc-web-react-library';
import ASRVPQuickStatusView from './ASRVP-QuickStatusView';
import { info_icon } from '../shared/iconSvgs';
import ValidationErrors from '../shared/ValidationErrors';
import GlobalAlert from '../shared/GlobalAlert';

const AthleteSafetyRVP = () => {
    const { getCompliance, loading: complianceLoading } = useManageApi();
    const { getAspTrainingAvailable,  loading: aspTrainingAvailableLoading } = useManageApi();
    const { getSafeSportTrainingAvailable, loading: ssTrainingAvailableLoading} = useManageApi();
    const [complianceModel, setComplianceModel] = useState();
    const [validationErrors, setValidationErrors] = useState(null);
    const [isRedirecting, setIsRedirecting] = useState(false);
    const [safeSportTrainingAvailable, setSafeSportTrainingAvailable] = useState(null);
    const [aspTrainingAvailable, setAspTrainingAvailable] = useState(null);

    useEffect(() => {
        setIsRedirecting(false);
        getCompliance({
            onError: (errors) => {
                setValidationErrors(errors);
                // Scroll to the top of the page
                window.scrollTo(0, 0);
            }
        }).then((result) => {
            setComplianceModel(result?.data);
        });
        getSafeSportTrainingAvailable().then((result) => {
            setSafeSportTrainingAvailable(result?.data);
        });
        getAspTrainingAvailable().then((result) => {
            setAspTrainingAvailable(result?.data);
        });
    }, []);


    return (
        <div className='athleteSafetyRvp'>
            <GlobalAlert/>
            {validationErrors && <ValidationErrors className="validation-errors alert alert-danger mt-3" validationErrors={validationErrors} />}
            <LoadingComponent isLoading={() => aspTrainingAvailableLoading || ssTrainingAvailableLoading} description={"Loading... Please Wait"}>
                {aspTrainingAvailable === false &&
                    <div className="rvp-header-card card alert alert-warning">
                        <div className="row g-0">
                            <div className="rvp-header-card-icon col-md-1 d-flex flex-wrap align-content-center justify-content-center">
                                {info_icon}
                            </div>
                            <div className="rvp-header-card-text col-md-11 container">
                                <div style={{ fontWeight: 'bold' }}>IMPORTANT NOTICE</div>
                                <div>The Athlete Safety Portal is currently down for maintenance. During this timeframe access will be unavailable.</div>
                            </div>
                        </div>
                    </div>
                }
                {aspTrainingAvailable === true && 
                    <LoadingComponent isLoading={() => complianceLoading | isRedirecting}
                        description={complianceLoading ? "Loading User Information... Please Wait." : isRedirecting ? "Redirecting.. Please Wait." : ""}>
                         {(!complianceModel || complianceModel?.isError === true) && !validationErrors &&
                            <div className="rvp-header-card card alert alert-danger">
                                <div className="rvp-header-card-text container">
                                    There was an issue getting user information, please contact support.
                                </div>
                            </div>
                        }
                        {complianceModel && complianceModel?.isError === false &&
                            <>
                                {safeSportTrainingAvailable === false &&
                                    <div className="rvp-header-card card alert alert-warning">
                                        <div className="row g-0">
                                            <div className="col-md-1 d-flex flex-wrap align-content-center justify-content-center">
                                                {info_icon}
                                            </div>
                                            <div className="col-md-11 container">
                                                The SafeSport Training is currently down for maintenance. During this timeframe access to all courses will be unavailable.
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className='text-end fw-bold'>{(complianceModel?.fullName ? complianceModel.fullName : "") + (complianceModel?.nationalId ? " (" + complianceModel?.nationalId + ")" : "")}</div>
                                <div className="rvp-header-card card">
                                    <div className="row g-0">
                                        <div className="rvp-header-card-text container">
                                            The United States Bowling Congress’ Athlete Safety Program combines the U.S. Center for SafeSport Policies and USBC’s Registered Volunteer Program
                                            into one comprehensive program. This program is designed to create awareness about emotional, physical and sexual abuse through education and prevention policies.
                                        </div>
                                    </div>
                                </div>

                                <div className='rvp-content'>
                                    <div className='quick-status-view container d-md-none mt-3'>
                                        <ASRVPQuickStatusView model={complianceModel} />
                                    </div>
                                    <br />
                                    <div className="container">
                                        <div className="row align-items-start g-4">
                                            <div id='asrvp-membership-container' className="col-lg-4">
                                                <ASRVPMembership model={complianceModel}
                                                />
                                            </div>
                                            <div id='asrvp-training-container' className="col-lg-4">
                                                <ASRVPTraining model={complianceModel} setValidationErrors={setValidationErrors} setIsRedirecting={setIsRedirecting} safeSportTrainingAvailable={safeSportTrainingAvailable}
                                                />
                                            </div>
                                            <div id='asrvp-background-screening-container' className="col-lg-4">
                                                <ASRVPBackgroundScreening model={complianceModel}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </>
                        }
                    </LoadingComponent>
                }
            </LoadingComponent>
            <br />
            <span>
                Should you have any questions about these requirements, please go to <a href="http://www.Bowl.com/RVP" target="_blank" rel="noopener noreferrer">BOWL.com/RVP</a> or contact <a href="mailto:RegisteredVolunteers@bowl.com?subject=Registered%20Volunteer%20Question" target="_blank">RVP@bowl.com</a>.
            </span>
        </div>
    );
}

export default AthleteSafetyRVP